import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ConfigurationService } from '@services/configuration.service';

import { Observable, of as observableOf } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class BtlCmsService {
    protected cache: { [index: string]: Observable<any> } = {};

    constructor(
        private http: HttpClient,
        private configurationService: ConfigurationService,
    ) {}

    public getContent(blockId: string, battlefront: boolean, addIndexHtmlToUrl: boolean): Observable<any> {
        if (!this.cache[blockId]) {
            const block$ = this.getBlock(blockId, battlefront, addIndexHtmlToUrl);
            block$.pipe(
                tap((data) => {
                    this.cache[blockId] = observableOf(data);
                }),
            );
            return block$;
        }
        return this.cache[blockId];
    }

    private getUri(blockId: string, battlefront: boolean, addIndexHtmlToUrl: boolean): string {
        if (battlefront) {
            return `${this.configurationService.getData()?.global.cms.battlefront}/${blockId}${
                addIndexHtmlToUrl ? '/index.html' : ''
            }?trilogy=-1`;
        } else {
            return `${this.configurationService.getData()?.global.cms.bta}${blockId}`;
        }
    }

    private getBlock(blockId: string, battlefront: boolean, addIndexHtmlToUrl: boolean): Observable<any> {
        const uri = this.getUri(blockId, battlefront, addIndexHtmlToUrl);
        return this.http.get(uri, { responseType: 'text' }).pipe(map((response) => ({ html: response })));
    }
}
